import "./featured.scss"
import React, { useEffect, useState } from 'react';
import { getCurrentTerm} from '../../services/termService';

export const Featured = () => {

  const [term, setTerm] = useState(null);
  const fetchTerm = async () => {
      try {
          const data = await getCurrentTerm();
         // console.log(data);
          const termData = data.data;
          if (termData && termData.name == 'Term IV') {
          termData.phase = 'Phase 1';
          }

          if (termData && termData.name == 'V') {
          termData.phase = 'Phase 2';
          }

          if (termData && termData.name == 'VI') {
          termData.phase = 'Phase 3';
          }

          setTerm(termData);
      } catch (err) {
          
      } 
  };
  useEffect(() => {      

      fetchTerm();
  }, []);

  const pdfFiles = [
    { name: 'Session 1', url: '/pdfs/session1.pdf' },
    { name: 'Session 2', url: '/pdfs/brochure.pdf' },
    { name: 'Session 3', url: '/pdfs/brochure.pdf' },
  ];

  const recordingFiles = [
    { name: 'Session 1', url: 'https://drive.google.com/file/d/1sTisNtlYJRIs1u6vgi3bln91GZLnFELx/view?usp=sharing' },
    { name: 'Session 2', url: '/pdfs/brochure.pdf' },
    { name: 'Session 3', url: '/pdfs/brochure.pdf' },
  ];

  const handlePDFSelect = (event) => {
    const selectedPdf = event.target.value;
    if (selectedPdf) {
      window.open(selectedPdf, '_blank'); // Opens the PDF in a new tab
    }
  }

  return (
     
    <div className="featured">
     <div>
        <ul className="pdf-list" style={{ display: 'flex', gap: '30px', alignItems: 'center' }}>
         {/* <li>
            <a href="/pdfs/brochure.pdf" target="_blank" rel="noopener noreferrer">
              Web Enabled Mtech Program
            </a>
          </li> */}
          <li>
            <div className="pdf-dropdown">
              <label htmlFor="pdfSelector">Session Presentations </label>
              <select id="pdfSelector" onChange={handlePDFSelect}>
                <option value="">Select a Session</option>
                {pdfFiles.map((pdf, index) => (
                  <option key={index} value={pdf.url}>
                    {pdf.name}
                  </option>
                ))}
              </select>
            </div>
          </li>
          <li>
            <div className="pdf-dropdown">
              <label htmlFor="pdfSelector">Session Recordings </label>
              <select id="pdfSelector" onChange={handlePDFSelect}>
                <option value="">Select a Session</option>
                {recordingFiles.map((pdf, index) => (
                  <option key={index} value={pdf.url}>
                    {pdf.name}
                  </option>
                ))}
              </select>
            </div>
          </li>

        </ul>
      </div>

      <div className="details">
        <h2>Current Term( <span style={{ color: 'red' }}>{term && term.name + '-' + term.phase}</span> ) details</h2>
        <ul className="pdf-list">

          <li>
            Term Start Date : <span style={{ color: 'red' }}>{term && term.startDate?term.startDate:'To be decided'}</span>
          </li>
          <li>
            End Term Date : <span style={{ color: 'red' }}>{term && term.endDate?term.endDate:'To be decided'}</span>
          </li>
          {term?.name === 'Term IV' && (
          <li>
            Project Particular Submission Date : <span style={{ color: 'red' }}>{term && term.midSemDate?term.midSemDate:'To be decided'}</span>
          </li>
          )}
          {term?.name === 'Term IV' && (
          <li>
            Project Proposal Submission Date : <span style={{ color: 'red' }}>{term && term.endSemDate?term.endSemDate:'To be decided'}</span>
          </li>
          )}
          <li>
            End Term Report Submission Date : <span style={{ color: 'red' }}>{term && term.submissionDate?term.submissionDate:'To be decided'}</span>
          </li>
        </ul>
      </div>



    </div>
  )
}
